import React from 'react';
import { Box, Typography, List, ListItem, ListItemText, Divider } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import FlashOnIcon from '@mui/icons-material/FlashOn';
import styles from './EVNDetailsTree.styles';
import { useNavWithTrail } from '../../../../layouts/TrailProvider';

export default function EVNDetailsTree({ meters = [], unitName = null, evnNumber = null }) {
  const navigate = useNavigate();
  const nav = useNavWithTrail(navigate);

  const goToMeter = (meter) => {
    const key = meter.MeterNumber || meter.name || meter.id;
    if (!key) return;

    nav(`/home/meters/${encodeURIComponent(key)}`, {
      state: {
        unit: unitName ?? null,
        evn: evnNumber ?? null,
      },
    });
  };

  const onMeterKey = (e, meter) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      goToMeter(meter);
    }
  };

  return (
    <Box sx={styles.root}>
      <Box sx={styles.scroll}>
        <Divider sx={styles.sectionDivider} textAlign="left">
          Meters
        </Divider>

        <List disablePadding>
          {meters.map((meter) => {
            const id = meter.id || meter.MeterNumber || meter.name || String(Math.random());
            const label = meter.MeterNumber || meter.name || 'Unnamed Meter';

            return (
              <ListItem key={id} disableGutters sx={styles.row}>
                <FlashOnIcon sx={styles.icon} />
                <ListItemText
                  primary={
                    <Typography
                      component="span"
                      role="link"
                      tabIndex={0}
                      aria-label={`Open meter ${label}`}
                      onClick={() => goToMeter(meter)}
                      onKeyDown={(e) => onMeterKey(e, meter)}
                      sx={styles.link}
                    >
                      {label}
                    </Typography>
                  }
                />
              </ListItem>
            );
          })}
        </List>
      </Box>
    </Box>
  );
}